document
	.querySelector('#form1 > .section > .aside > .nav > ul')
	.addEventListener('click', event => {
		if (!event.target.matches('#form1 > .section > .aside > .nav > ul > li > .nav-nolink')) {
			return
		}
		event.target.classList.toggle('cms-menuts-on')
	})
